/**
 * API地址
 */
// export const API_SERVER = "https://yllh.huadu.gov.cn:8000";

// export const API_SERVER = "http://192.168.0.109:8000";
export const API_SERVER = "https://gzzpyy.boiry.com.cn:9201";
// export const API_SERVER = "http://garden.boiry.com.cn:8000";

/**
 * 文件服务地址
 */
// export const FILE_SERVER = "http://192.168.0.109:8006";
export const FILE_SERVER = "https://gzzpyy.boiry.com.cn:9206";

/**
 * 微信APPID
 */
export const WX_APPID = "wx6de5e67a2c9f93f1";
